import styled from '@emotion/styled/macro';

import { Name } from '../../../pages/MemberOverviewPage/Modals/Common/memberOverviewModals.styles';

export const StyledName = styled(Name)`
  margin: 0.5rem 0;
`;
